import { ListItem } from "./display/ListItem.js";
import { Map, MapTileServer } from "./display/Map.js";
import { MapToggle } from "./display/MapToggle.js";
import { Marker } from "./display/Marker.js";
import { DataManager } from "./model/DataManager.js";

export class ImmoCategory {

    private _data: DataManager;
    private _showMap: boolean = true;
    private _map: Map;

    private _list: HTMLDivElement;
    private _listContent: HTMLDivElement;
    private _mapElement: HTMLDivElement;
    private _toggle: MapToggle;
    private _markers: Marker[] = [];

    constructor(public element: HTMLDivElement) {
        console.log("[ImmoCategory]");

        this.init();
    }

    private async init() {
        this._data = new DataManager();
        await this._data.load(this.element.getAttribute("data-dataurl"));

        var hash = window.location.hash.substring(1);

        var immoId: number = 0;
        if (hash
            && hash.indexOf("/") !== -1) {
            var vals = hash.split("/");
            if (vals.length === 2) {
                var cat = vals[0];
                immoId = parseInt(vals[1]);
                if (isNaN(immoId)) {
                    immoId = 0;
                }
                if (cat === "list") [
                    this._showMap = false,
                ]
            }
        }

        this.element.innerHTML = `
        <div class="e5-map__content">
            <div class="e5-map__map "></div>
            <div class="e5-map__list e5-hidden">
                <div class="e5-map__list-content e5-container"></div>
            </div>
        </div>
        <div class="e5-base__loader"></div>
        `;

        this._toggle = new MapToggle({
            state: this._showMap ? "map" : "list"
        });
        this._toggle.onToggle.add((state) => {
            this.showMap = state == "map";
        });
        this.element.prepend(this._toggle.element);

        this._list = this.element.querySelector(".e5-map__list");
        this._listContent = this.element.querySelector(".e5-map__list-content");
        this._mapElement = this.element.querySelector(".e5-map__map");


        var bounds: L.LatLngBounds = new L.LatLngBounds(null, null);
        for (var immo of this._data.data.bis_immo) {
            bounds.extend(immo.position);
            var m = new Marker(immo);
            this._markers.push(m);
            if (m.feature) {
                bounds.extend(m.feature.getBounds());
            }
        }

        this._map = new Map(this.element.querySelector(".e5-map__map"), {
            tileServer: this.element.getAttribute("data-tileserver") as MapTileServer,
            supportPrint: false,
            bounds: bounds
        });

        for (var m of this._markers) {
            m.marker.addTo(this._map.map);
            if (m.feature) {
                m.feature.addTo(this._map.map);
            }
        }


        for (var immo of this._data.data.bis_immo) {
            var item = new ListItem(immo);
            this._listContent.appendChild(item.element);
        }

        this.updateLayout();

        if (immoId) {
            if (this._showMap) {
                this.highlightMarker(immoId);
            } else {
                var e = this._list.querySelector(`[data-immoid="${immoId}"]`) as HTMLDivElement;
                if (e) {
                    this._list.scrollTop = e.offsetTop;
                }
            }
        }

        e5.on(this.element, "click", "[data-showonmap]", (e) => {
            var immoId = parseInt(e.target.getAttribute("data-showonmap"));
            var immo = this._data.data.bis_immo.id(immoId);
            if (immo) {
                this.showMap = true;
                this.highlightMarker(immoId);
            }
        });

        this.element.querySelector(".e5-base__loader").remove();
    }

    private highlightMarker(immoId: number): void {
        var immo = this._data.data.bis_immo.id(immoId);
        if (this._showMap && immo) {

            for (var m of this._markers) {
                if (m.data === immo) {
                    this._map.show(immo.position, m.feature ? m.feature.getBounds() : null);
                    m.highlight();
                    if(m.popup){
                        m.popup.open();
                    }
                    break;
                }
            }
        }
    }

    private get showMap(): boolean {
        return this._showMap;
    }

    private set showMap(value: boolean) {
        if (this._showMap === value) {
            return;
        }
        this._showMap = value;
        this.updateLayout();
    }

    private updateLayout(): void {
        var value = this._showMap;
        this._toggle.state = value ? "map" : "list";
        this._mapElement.classList.toggle("e5-hidden", !value);
        this._list.classList.toggle("e5-hidden", value);
        if (value) {
            this._map.resize();
        }
    }
}

document.addEventListener("DOMContentLoaded",
    () => {
        var e = document.querySelector<HTMLDivElement>(".e5-map");
        if (e) {
            new ImmoCategory(e);
        }
    }
);